import { gql } from '__generated__';

export default gql(`
  query GetEventsForMailPermissions($id: ID!) {
    project(id: $id) {
      id
      events {
        data {
          id
          title
        }
      }
      integrations(types: [mailchimp, active_campaign]) {
        id
        title
        type
        mailchimp {
          id
          account_name
          audiences {
            id
            name
          }
        }
        active_campaign {
          id
          account_name
          lists {
            id
            name
          }
        }
      }
    }
  }
`);
